// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3CEyy","title":"Header_title__37icx","side":"Header_side__14j0W"};